import React from 'react';
import { ReturnWrapper, Heading, Content } from './styles';

export const Returns = () => {
  return (
    <ReturnWrapper>
      <Heading>Return Policy</Heading>
      <Content>
        At this time we don't offer any returns or exchanges. If your earrings
        arrive damaged or break within 30 days please contact me. Please do not
        bend your earrings. Even though the clay is bendable it can make them
        brittle and cause them to break
      </Content>
    </ReturnWrapper>
  );
};
